import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Image } from 'react-bootstrap';
import home1 from '../assets/castello2.jpg';
import preview from '../assets/team/preview.jpg';

import AndreaBertazzon from '../assets/team/AndreaBertazzon.jpg';
import AnnaBattistuzzi from '../assets/team/AnnaBattistuzzi.jpg';
import CarlottaFurlan from '../assets/team/CarlottaFurlan.jpg';
import LucaBellotto from '../assets/team/LucaBellotto.jpg';
import MarcoCekada from '../assets/team/MarcoCekada.jpg';
import MarcoPoveglian from '../assets/team/MarcoPoveglian.jpg';
import MattiaCenedese from '../assets/team/MattiaCenedese.jpg';
import NicolaPiccoli from '../assets/team/NicolaPiccoli.jpg';
import SoniaSpinazze from '../assets/team/SoniaSpinazze.jpg';
import TommasoTomasi from '../assets/team/TommasoTomasi.jpg';
import VeronicaCalesso from '../assets/team/VeronicaCalesso.jpg';
import LucreziaAggio from '../assets/team/LucreziaAggio.jpg';
import AnnaMomesso from '../assets/team/AnnaMomesso.jpg';
import RyanPerin from '../assets/team/RyanPerin.jpg';
import IlariaAffabris from '../assets/team/IlariaAffabris.jpg';
import AlessandraSalatino from '../assets/team/AlessandraSalatino.jpg';
import SaraGallon from '../assets/team/SaraGallon.jpg';
import PaoloBosi from '../assets/team/PaoloBosi.jpg';


const divisions = [
    {
        area: 'Logistica',
        referente: { name: 'Veronica Calesso', photo: VeronicaCalesso },
        team: [
            { name: 'Tommaso Tomasi', photo: TommasoTomasi },
            { name: 'Andrea Bertazzon', photo: AndreaBertazzon },
            { name: 'Anna Battistuzzi', photo: AnnaBattistuzzi },
            { name: 'Martina Zaina', photo: preview },
            { name: 'Marta Battistuzzi', photo: preview },
            { name: 'Alessandra Salatino', photo: AlessandraSalatino },
            { name: 'Pierfrancesco Panizza', photo: preview },
            { name: 'Leonardo Forin', photo: preview },
            { name: 'Paolo Bosi', photo: PaoloBosi },
            { name: 'Leonardo Canzian', photo: preview },
        ],
    },
    {
        area: 'Ospiti',
        referente: { name: 'Anna Pozzobon', photo: preview },
        team: [
            { name: 'Lucrezia Aggio', photo: LucreziaAggio },
        ],
    },
    {
        area: 'Speaker',
        referente: { name: 'Sonia Spinazzè', photo: SoniaSpinazze },
        team: [
            { name: 'Marco Poveglian', photo: MarcoPoveglian },
        ],
    },
    {
        area: 'Partner',
        referente: { name: 'Luca Bellotto', photo: LucaBellotto },
        team: [
            { name: 'Marco Anzil', photo: preview },
        ],
    },
    {
        area: 'Comunicazione',
        referente: { name: 'Carlotta Furlan', photo: CarlottaFurlan },
        team: [
            { name: 'Marco Cekada', photo: MarcoCekada },
            { name: 'Michelle Vincenzi', photo: preview },
            { name: 'Mattia Cenedese', photo: MattiaCenedese },
            { name: 'Anna Momesso', photo: AnnaMomesso },
            { name: 'Ryan Perin', photo: RyanPerin },
            { name: 'Ilaria Affabris', photo: IlariaAffabris },
            { name: 'Sara Gallon', photo: SaraGallon },
            { name: 'Nicola Piccoli', photo: NicolaPiccoli },
        ],
    },
    {
        area: 'Foto / Video',
        referente: { name: 'Nicola Piccoli', photo: NicolaPiccoli },
        team: [],
    },
];


export default function Team() {

    return (
        <>
            <Helmet>
                <title>Il Team di TEDxConegliano</title>
                <meta name="description" content="" />
            </Helmet>


            <Container fluid className='pt-5 pb-5 ps-0 pe-0 bg-slide height-100 slide-gradient-red align-items-end' style={{backgroundColor:'#eee', backgroundImage:'url('+home1+')'}}>
                <Container fluid="md" className='text-start p-5 text-white' style={{zIndex: 1}}>
                    <h5>TEAM</h5>
                    <h1 className='mt-5 mb-5' style={{maxWidth:700}}>
                        Lʼunione fa la forza
                    </h1>

                    <p className='lead' style={{maxWidth:700}}>
                        Il nostro team è una fusione dinamica di giovani talenti provenienti
                        da diverse sfere della culturali e professionali
                    </p>

                    <div className='mt-5 mb-5'>
                        <a href='mailto:info@tedxconegliano.it' target='_blank'>
                            <span className='button-52-light m-auto'>
                                Entra anche tu
                            </span>
                        </a>
                    </div>

                </Container>
            </Container>


            <Container fluid className='pt-5 pb-5 ps-0 pe-0'>
                <Container fluid="md" className='text-start p-5'>
                    <Row className='align-items-start'>
                        <Col xs={12} lg={2} className='pb-5'>
                            <h5 style={{color:'#eb0028'}}>TEAM</h5>
                        </Col>
                        <Col xs={12} lg={1}></Col>
                        <Col xs={12} lg={3} className='pb-5'>
                            <h3 className='mb-5'>
                                Una squadra unita dallo stesso obiettivo!
                            </h3>
                        </Col>
                        <Col xs={12} lg={1}></Col>
                        <Col xs={12} lg={5} className='pb-5'>
                            <p className='lead mb-5'>
                                Il nostro team è una fusione dinamica di
                                giovani talenti provenienti da diverse sfere
                                della culturali e professionali
                            </p>
                            <p>
                                Guidati dalla passione per il territorio, l'innovazione e il
                                cambiamento, insieme, formiamo un gruppo diversificato e
                                complementare, unito dalla missione di ispirare,
                                condividere idee che trasformano il nostro territorio per il meglio.
                            </p>

                            <div className='mt-5 mb-5'>
                                <a href='mailto:info@tedxconegliano.it' target='_blank'>
                                    <span className='button-52 m-auto'>
                                        Entra anche tu
                                    </span>
                                </a>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </Container>


            <Container fluid className='pt-5 pb-5 ps-0 pe-0' style={{backgroundColor:'#eee'}}>
                <Container fluid="md" className='text-start p-5'>

                    <Row className='align-items-start mb-5'>
                        <Col xs={12} lg={3} className='pb-5'>
                            <h5 style={{color:'#eb0028'}}>LICENSEE</h5>
                            <p>Fondatore e licenziatario di TEDxConegliano</p>
                        </Col>
                        <Col xs={12} lg={1}></Col>
                        <Col xs={12} lg={8}>
                            <Row>
                                <Col xs={6} lg={4}>
                                    <Image src={LucaBellotto} width={'100%'} />
                                    <p style={{color:'#eb0028'}} className='lead mt-4 mb-1'>Luca Bellotto</p>
                                    <p className='text-muted'>Licensee TEDxConegliano</p>
                                </Col>
                            </Row>
                        </Col>
                    </Row>

                    {divisions.map((div, i) => (
                        <Row key={i} className='align-items-start pt-5 mt-5' style={{borderTop:'1px solid #ddd'}}>
                            <Col xs={12} lg={3} className='pb-5'>
                                <h5 style={{color:'#eb0028'}}>{div.area.toUpperCase()}</h5>
                                <p>Tutti con competenze trasversali uniti verso lo stesso obiettivo</p>
                            </Col>
                            <Col xs={12} lg={1}></Col>
                            <Col xs={12} lg={8} className='pb-5'>
                                <Row>
                                    <Col xs={6} lg={4} className='mb-5'>
                                        <Image src={div.referente.photo} width={'100%'} />
                                        <p style={{color:'#eb0028'}} className='lead mt-4 mb-1'>{div.referente.name}</p>
                                        <p className='text-muted'>Referente - Team {div.area}</p>
                                    </Col>
                                    {div.team.map((p, j) => (
                                        <Col key={j} xs={6} lg={4} className='mb-5'>
                                            <Image src={p.photo} width={'100%'} />
                                            <p style={{color:'#eb0028'}} className='lead mt-4 mb-1'>{p.name}</p>
                                            <p className='text-muted'>Team {div.area}</p>
                                        </Col>
                                    ))}
                                </Row>
                            </Col>
                        </Row>
                    ))}

                </Container>
            </Container>


            <Container fluid className='pt-5 pb-0 ps-0 pe-0' style={{background:'#eb0028'}}>
                <Container fluid="md" className='text-start p-5 text-white'>
                    <Row className='align-items-start'>
                        <Col xs={12} lg={2} className='pb-5'>
                            <h5>TEAM</h5>
                        </Col>
                        <Col xs={12} lg={1}></Col>
                        <Col xs={12} lg={3} className='pb-5'>
                            <p className='lead'>Unisciti anche tu alla nostra squadra e costruiamo qualcosa di unico</p>
                        </Col>
                        <Col xs={12} lg={1}></Col>
                        <Col xs={12} lg={5} className='pb-5'>
                            <p className='pb-5'>
                                Sostieni concretamente le nostre idee e fatti coinvolgere per diventare un attore principale del cambiamento
                            </p>

                            <div className='mt-5 mb-5'>
                                <Link to="/contact">
                                    <span className='button-52-light m-auto'>
                                        Contatti
                                    </span>
                                </Link>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </Container>

        </>
    );
};
